import { useMemo } from 'react';

export const usePeriodTooLong = ({
  date_from, date_to, year, last_day,
}) => useMemo(() => {
  if (year && last_day) {
    const dateOfLastDay = new Date(last_day);
    const dateOfYear = new Date(year);

    return dateOfLastDay.getFullYear() - dateOfYear.getFullYear() !== 0;
  } if (date_from && date_to) {
    const from = new Date(date_from);
    const to = new Date(date_to);
    return to.getFullYear() - from.getFullYear() !== 0;
  }
  return false;
}, [date_from, date_to, last_day, year]);
